export const NotificationStatus = {
   NEW: 'NEW',
   PROCESSING: 'PROCESSING',
   ACCEPTED: 'ACCEPTED',
   DELETED: 'DELETED',
   ERROR: 'ERROR',
};
